import Vue from "vue";
import VueRouter from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import Login from "../views/Login.vue";
import ResetPassword from "../views/ResetPassword";
import ChangePassword from "../views/ChangePassword";
import Logout from "../views/Logout.vue";
import Settings from "../views/Settings.vue";
import Bookings from "../views/Bookings.vue";
import Reports from "../views/Reports.vue";
import SalesReport from "../views/SalesReport";
import SalesReportEdit from "../views/SalesReportEdit";
import ActivityReport from "../views/ActivityReport";
import InvoiceHistory from "../views/InvoiceHistory";
import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "dashboard",
    component: Dashboard,
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },

  {
    path: "/bookings",
    name: "bookings",
    component: Bookings,
  },

  {
    path: "/reports/:show",
    name: "reports",
    component: Reports,
    props: true,
  },

  {
    path: "/reports",
    name: "reports",
    component: Reports,
    props: true,
  },

  {
    path: "/reports/sales/:id",
    name: "sales-report",
    component: SalesReport,
    props: true,
  },

  {
    path: "/reports/sales-report-item/:id",
    name: "sales-report-item",
    component: SalesReportEdit,
    props: true,
  },

  {
    path: "/reports/activity/:id",
    name: "activity-report",
    component: ActivityReport,
    props: true,
  },

  {
    path: "/settings",
    name: "settings",
    component: Settings,
  },

  {
    path: "/invoices",
    name: "invoices",
    component: InvoiceHistory,
  },

  {
    path: "/login",
    name: "login",
    component: Login,
    props: true,
    meta: {
      guest: true,
    },
  },

  {
    path: "/reset",
    name: "reset",
    component: ResetPassword,
    props: true,
    meta: {
      guest: true,
    },
  },

  {
    path: "/change-password",
    name: "change-password",
    component: ChangePassword,
    props: true,
    meta: {
      guest: true,
    },
  },

  {
    path: "/logout",
    name: "logout",
    component: Logout,
    props: true,
    meta: {
      guest: true,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  // const isAuthenticated = (store && store.state && store.state.isAuthenticated) || false
  const isAuthenticated = store.getters["isAuthenticated"] || false;
  if (!to.matched.some((record) => record.meta.guest)) {
    if (!isAuthenticated) {
      console.info("not authenticated, redirecting to login");
      next({
        name: "login",
        params: { nextUrl: to.fullPath },
      });
    } else {
      console.info("authenticated, allowing access");
      next();
    }
  }
  next();
});

export default router;
